'use client';

import { ErrorComponent } from '~/components/ErrorComponent';

export default function ErrorPage() {
  return (
    <ErrorComponent
      errorCode="500"
      errorTitle="Internal Server Error"
      errorMessage="An unexpected error occurred while trying to process your request. Please try again later."
      homeLink="/"
    />
  );
}
